import { faCheck } from '@fortawesome/pro-regular-svg-icons';

import AgentBadge from './AgentBadge.tsx';
import { cardIconFor } from './categoryIcons.tsx';
import classnames from '../../../core/utils/classnames.tsx';

export type RecommendedCategory = {
    id: string;
    name: string;
    detectionCriteria: string;
    supportingKeywords: string[];
    tag?: string;
    tagColor?: string;
    sourceType?: string;
};

type Props = {
    recommendations: RecommendedCategory[];
    loading: boolean;
    selectedIds: Set<string>;
    onToggle: (id: string) => void;
    assistantBadge?: boolean;
};

const RecommendedCategoriesGrid = ({
    recommendations,
    loading,
    selectedIds,
    onToggle,
    assistantBadge = false,
}: Props) => (
    <div className="grid grid-cols-2 gap-3">
        {loading
            ? Array.from({ length: 4 }).map((_, i) => (
                  <div key={i} className="animate-pulse border rounded-lg p-4 h-24 bg-surface-medium" />
              ))
            : recommendations.map((rec) => {
                  const isSelected = selectedIds.has(rec.id);
                  const CardIcon = cardIconFor(rec.name);
                  return (
                      <button
                          key={rec.id}
                          type="button"
                          onClick={() => onToggle(rec.id)}
                          className={classnames(
                              'relative flex flex-row border cursor-pointer rounded-lg p-4 text-left transition-colors hover:bg-surface-medium hover:shadow-sm ',
                              isSelected
                                  ? 'border-line-brand-default bg-surface-brand-weak text-content-brand-default hover:bg-surface-brand-weak'
                                  : 'border-line-weak hover:border-line-hover'
                          )}
                      >
                          <CardIcon
                              className={classnames(
                                  'mr-3 mt-0.5 text-content-strong flex-none',
                                  isSelected && 'text-content-brand-default'
                              )}
                          />
                          <div className="flex flex-col w-full min-w-0">
                              <div className="flex flex-row items-center gap-2 mb-2">
                                  <span
                                      className={classnames(
                                          'text-sm font-medium text-content-strong truncate',
                                          isSelected && 'text-content-brand-default'
                                      )}
                                  >
                                      {rec.name}
                                  </span>
                                  {rec.sourceType === 'AGENT' && (
                                      <AgentBadge
                                          assistant={assistantBadge}
                                          className={classnames(
                                              'border border-solid ml-auto',
                                              assistantBadge ? 'border-line-agent-weak' : 'border-line-brand-weak'
                                          )}
                                      />
                                  )}
                              </div>
                              <span
                                  className={classnames(
                                      'text-sm font-normal text-content-default line-clamp-2 mt-1',
                                      isSelected && 'text-content-brand-default'
                                  )}
                              >
                                  {rec.detectionCriteria}
                              </span>
                          </div>
                      </button>
                  );
              })}
    </div>
);

export default RecommendedCategoriesGrid;
